import { useState } from "react";
import { useTranslation } from "react-i18next";

const faqKeys = [
  { qKey: "faq.q0", aKey: "faq.a0" },
  { qKey: "faq.q1", aKey: "faq.a1" },
  { qKey: "faq.q2", aKey: "faq.a2" },
  { qKey: "faq.q3", aKey: "faq.a3" },
  { qKey: "faq.q4", aKey: "faq.a4" },
  { qKey: "faq.q5", aKey: "faq.a5" },
];

export default function FAQ() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="relative py-24 md:py-32 bg-background-50 overflow-hidden">
      <div className="relative max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-left max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold">
            <span className="w-2 h-2 rounded-full bg-primary-600"></span>
            {t("faq.badge")}
          </span>
          <h2 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight">
            <span style={{ color: "#215E88" }}>{t("faq.h2_part1")}</span>{" "}
            <span className="brand-gradient-text">{t("faq.h2_gradient")}</span>
          </h2>
        </div>

        <div className="mt-14 space-y-3">
          {faqKeys.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.qKey}
                className={`glass-card rounded-lg border ${
                  isOpen ? "border-[#02B36D]/40" : "border-background-200/70"
                } transition-colors`}
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-start justify-between gap-4 px-5 md:px-6 py-5 text-left cursor-pointer"
                >
                  <span className="font-heading text-base md:text-lg font-bold pt-[6px]" style={{ color: "#215E88" }}>
                    {t(f.qKey)}
                  </span>
                  <span
                    className={`w-9 h-9 min-w-[36px] min-h-[36px] shrink-0 flex items-center justify-center rounded-full transition-all ${
                      isOpen
                        ? "bg-[#02B36D] text-background-50 rotate-45"
                        : "bg-background-100 text-[#215E88]"
                    }`}
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-add-line text-lg"></i>
                    </span>
                  </span>
                </button>
                {isOpen && (
                  <div
                    className="px-5 md:px-6 pb-5 text-sm md:text-base leading-relaxed animate-fadeIn"
                    style={{ color: "#215E88" }}
                  >
                    {t(f.aKey)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}